// BudgetCountyPracticeScheduleItem_Update stamps every row with the root
// budget_county_practice_id, so each returned group is one practice.
export function groupClonedScheduleItems(items, practiceIdByOldId, newId = () => crypto.randomUUID()) {
  const groups = new Map();
  if (!Array.isArray(items)) return [];

  for (const item of items) {
    const oldPracticeId = String(item?.budget_county_practice_id ?? "").toLowerCase();
    const budget_county_practice_id = practiceIdByOldId.get(oldPracticeId);
    if (!budget_county_practice_id) continue;

    const copy = {
      id: newId(),
      budget_county_practice_id,
      category: item.category,
      ordinal: item.ordinal,
      line_item_name: item.line_item_name,
      name: item.name,
      quantity: item.quantity,
      unit_of_measure: item.unit_of_measure,
      case_quantity: item.case_quantity,
      case_unit_of_measure: item.case_unit_of_measure,
      unit_value: item.unit_value,
      value: item.value,
      is_active: item.is_active,
      input_share_percent: item.input_share_percent,
    };

    const list = groups.get(budget_county_practice_id);
    if (list) list.push(copy);
    else groups.set(budget_county_practice_id, [copy]);
  }

  return [...groups.values()];
}
